import { IconSVG } from '../types';

export function Repeat({ size, style }: IconSVG) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill="currentColor"
        d="M6.85 19l.85.85c.2.2.296.433.287.7a1.02 1.02 0 01-1 1.012.93.93 0 01-.712-.287L3.7 18.7a.877.877 0 01-.213-.325A1.107 1.107 0 013.425 18c0-.133.02-.258.062-.375A.877.877 0 013.7 17.3l2.575-2.575a.93.93 0 01.712-.287c.275.008.513.112.713.312.183.2.279.433.287.7a.916.916 0 01-.287.7l-.85.85H17v-3c0-.283.096-.52.287-.713A.968.968 0 0118 13c.283 0 .52.096.712.287.192.192.288.43.288.713v3c0 .55-.196 1.02-.588 1.413A1.926 1.926 0 0117 19H6.85zm10.3-12H7v3c0 .283-.096.52-.288.713A.967.967 0 016 11a.967.967 0 01-.713-.287A.968.968 0 015 10V7c0-.55.196-1.02.587-1.412A1.926 1.926 0 017 5h10.15l-.85-.85a.916.916 0 01-.288-.7c.009-.267.104-.5.288-.7.2-.2.437-.304.712-.312a.93.93 0 01.713.287L20.3 5.3c.1.1.17.208.212.325.042.117.063.242.063.375s-.021.258-.063.375a.878.878 0 01-.212.325l-2.575 2.575a.93.93 0 01-.713.288 1.02 1.02 0 01-.712-.313c-.184-.2-.28-.433-.288-.7a.916.916 0 01.288-.7l.85-.85z"
      />
    </svg>
  );
}
